import { request } from '@/plugins/http';

/**
 * 历史数据下载列表
 * @param params
 * @returns {AxiosPromise}
 */
const getDataHistoryDataPage = params => request('/deploy/getDataHistoryDataPage', params);

/**
 * 历史数据下载列表
 * @param params
 * @returns {AxiosPromise}
 */
const downASc = params => request('/vehicle/downASc?id='+params,{},'','get');

/**
 * 历史数据删除
 * @param params
 * @returns {AxiosPromise}
 */
const delDataHistoryData = params => request('/deploy/delDataHistoryData', params);

/**
 * 历史数据备注
 * @param params
 * @returns {AxiosPromise}
 */
const updateDataHistoryDataRemark = params => request('/deploy/updateDataHistoryDataRemark', params);

export {
    getDataHistoryDataPage,
    downASc,
    delDataHistoryData,
updateDataHistoryDataRemark
};
